import { cn } from '@/utils/cn';

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}

const FormSection = ({ title, children, className }: FormSectionProps) => {
  return (
    <div className={cn('bg-white rounded-lg shadow-sm border p-6', className)}>
      <h3 className="text-lg font-semibold mb-4 text-gray-800">{title}</h3>
      <div className="space-y-4">{children}</div>
    </div>
  );
};

export default FormSection;
